"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_BOOKING_ORDER_SLOT = void 0;
const client_1 = require("@apollo/client");
exports.UPDATE_BOOKING_ORDER_SLOT = client_1.gql `
  mutation updateBookingOrderSlot($input: InputUpdateBookingOrder!) {
    order: updateBookingOrderSlot(input: $input) {
      id
    }
  }
`;
